module.exports = __webpack_public_path__ + "img/dental-office-tour-front2.570540f0.jpeg";